<script>
import CardDailyMealsMinimal from '@components/cards/card-daily-meals-minimal.vue';
import CardGoals from '@components/cards/card-goals.vue';
// import carousel from 'vue-owl-carousel';
import WorkoutDetailsMobile from '@views/home/mobile/workout-details-mobile.vue';
import { homeComputed } from '@state/helpers';

export default {
  components: {
    CardDailyMealsMinimal,
    CardGoals,
    // carousel,
    WorkoutDetailsMobile,
  },
  data() {
    return {
      viewProgress: false,
      lineChartHeight: 0,
    };
  },
  mounted() {
    if (
      document.getElementsByClassName('goals-wrapper').length > 0 &&
      document.getElementsByClassName('goals-wrapper')[0].clientHeight > 0
    ) {
      this.lineChartHeight = document.getElementsByClassName('goals-wrapper')[0].clientHeight - 85;
    } else {
      this.lineChartHeight = 200;
    }
  },
  computed: {
    ...homeComputed,
  },
};
</script>

<template>
  <div>
    <div class="page">
      <div class="content-tab">
        <WorkoutDetailsMobile />
        <div class="section-wrapper">
          <CardDailyMealsMinimal />
        </div>
        <!-- TODO: add goals array to render goals-carousels -->
        <!-- <carousel
          class="goals-carousel"
          ref="goals-carousel"
          :autoplay="false"
          :nav="false"
          :center="true"
          :dots="false"
          :margin="5"
          :items="20"
          :autoWidth="true"
        > -->
        <template v-for="i in [1]">
          <div :key="i" class="goals-wrapper">
            <CardGoals :goals="homeOverview.goalCharts.weight" :lineChartHeight="lineChartHeight" />
          </div>
        </template>
        <!-- </carousel> -->
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-max-type
// stylelint-disable selector-pseudo-element-no-unknown

.content-tab {
  padding-bottom: 12rem;

  .section-wrapper {
    padding: 0 2rem;
  }
}

::v-deep .card-goals {
  height: 26vh;
  max-width: unset !important;

  // Remove when carousel array ready
  // ###########################
  max-width: 60rem;
  min-height: unset;
  width: 91vw;
  // ###########################
}

// Remove this when carousel array ready
// ###########################
.goals-wrapper {
  align-items: center;
  display: flex;
  justify-content: center;
  margin-left: 2rem;
  margin-right: 2rem;
  margin-top: 2.3rem;
  .card-goals {
    width: 100%;
  }
}
// ###########################

.owl-carousel {
  width: 100%;
}
::v-deep .owl-stage {
  display: flex;
  justify-content: flex-start;
  // padding-bottom: 3.5rem !important;
  // padding-top: 1rem !important;
  right: 8px;
}

::v-deep .owl-item {
  transition: all 0.25s ease-in-out;
  &.active {
    .goals-wrapper {
      padding-right: 0;
    }
  }
  &.center {
    margin-left: 12px !important;
    margin-right: 12px !important;
  }
  &:not(.center) {
    height: 95%;
    .goals-wrapper {
      ::v-deep .card-goals {
        height: 2rem;
        min-height: unset;
      }
    }
  }
}

.goals-carousel {
  ::v-deep .owl-stage {
    transform: translate3d(7vw, 0, 0) !important;
  }
  ::v-deep .owl-item {
    margin-left: unset;
    margin-right: auto !important;
  }
}

::v-deep .owl-carousel {
  .owl-stage {
    align-items: center;
    display: flex;
    justify-content: flex-start;
    // padding: 2rem 0;

    .owl-item:not(.center) {
      .card-goals.mobile {
        height: 23vh;
        min-height: unset;
      }
    }
  }
}

.tab-content {
  color: white;
  display: none;
  height: 100%;
  padding: 100px 20px;
}

.tab-pane {
  background-color: #f7f7f7;
  height: 100%;
  overflow: auto;
  width: 100%;
}
</style>
